export const SET_CURRENT_VERSION = 'appVersion/SET_CURRENT_VERSION';
export const SET_IS_RUNNING_LATEST_VERSION = 'appVersion/SET_IS_RUNNING_LATEST_VERSION';
export const SET_SHOULD_SHOW_UPDATE_MODAL = 'appVersion/SET_SHOULD_SHOW_UPDATE_MODAL';
